var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoftIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2262_6068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5625 17.4375H27V9.5625C27 9.41332 26.9407 9.27024 26.8352 9.16475C26.7298 9.05926 26.5867 9 26.4375 9H18.5625V17.4375Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4375 17.4375V9H9.5625C9.41332 9 9.27024 9.05926 9.16475 9.16475C9.05926 9.27024 9 9.41332 9 9.5625V17.4375H17.4375Z",
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4375 18.5625H9V26.4375C9 26.5867 9.05926 26.7298 9.16475 26.8352C9.27024 26.9407 9.41332 27 9.5625 27H17.4375V18.5625Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5625 18.5625V27H26.4375C26.5867 27 26.7298 26.9407 26.8352 26.8352C26.9407 26.7298 27 26.5867 27 26.4375V18.5625H18.5625Z",
    fill: "#FFC107"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2262_6068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftIcon);
export default __webpack_public_path__ + "static/media/microsoft_icon.7fe4bb236d216da0d04109a179d21cc1.svg";
export { ForwardRef as ReactComponent };